module.exports = __webpack_public_path__ + "static/media/ic_smoke.1c89fedc.png";